<!-- cypress stuff does not need to be translated -->
<template>
  <li class="list-unstyled m-3 text-white">
    <h3 class="mb-2 font-weight-bold school-name">{{ schoolName }}</h3>
    <ul class="list-unstyled m-0">
      <li v-for="(user, name) in limitUsers"
          :key="name"
          class="list-unstyled m-0"
      >
        <b-button class="cypress-user-switch-btn"
                  variant="transparent"
                  @click="selectUser(user)"
        >
          <span class="d-block w-100 lh-1">
            <span class="mb-0 title fz-base font-weight-bold">{{ user.meta.displayname }}</span>
            <span class="mb-0 subtitle"><b>{{ name }}</b> [{{ user.username }}]</span>
          </span>
        </b-button>
      </li>
      <li v-if="Object.keys(users).length > Object.keys(limitUsers).length" class="list-unstyled m-0">
        <b-button class="show-all-users-btn"
                  variant="transparent"
                  @click="showAllUsers = true"
        >
          <span class="show-all-users-btn--icon"><sdui-icon class="icon-school" /></span>
          <p class="mb-0">show more</p>
        </b-button>
      </li>
      <li v-if="hasAdmin" class="list-unstyled m-0">
        <b-button class="change-school-btn"
                  variant="transparent"
                  @click="switchSchool"
        >
          <span class="change-school-btn--icon"><sdui-icon class="icon-school" /></span>
          <p class="mb-0">Schule wechseln</p>
        </b-button>
      </li>
      <li class="list-unstyled m-0">
        <b-button v-b-toggle.monitor-collapse
                  variant="transparent"
                  class="monitor-btn"
        >
          <span class="monitor-btn--icon"><sdui-icon class="icon-school" /></span>
          <p class="mb-0">Monitor</p>
        </b-button>
        <div>
          <b-collapse id="monitor-collapse">
            <p class="ml-3">
              <SLink appearance="b-link"
                     :href="`/monitor/view?token=${schoolID}-sub`"
                     variant="primary"
                     target="_blank"
                     class="white"
              >
                Monitor-sub
              </SLink>
            </p>
            <p class="ml-3">
              <SLink
                appearance="b-link"
                :href="`/monitor/view?token=${schoolID}-news-split`"
                variant="primary"
                target="_blank"
                class="white"
              >
                Monitor-news-split
              </SLink>
            </p>
          </b-collapse>
        </div>
      </li>
    </ul>

    <SModal v-model="showAllUsers"
            :header-title="$t('cypress.choose_user')"
            hide-footer
    >
      <SList v-if="showAllUsers">
        <SListItem v-for="(user, name) in users"
                   :key="name"
                   :disabled="$wait.waiting('loadSchool')"
        >
          <template #item-title>
            <b-row class="no-gutters w-100">
              <b-col cols="6">
                <p class="mb-0">{{ user.meta.displayname }}</p>
                <p class="mb-0">
                  <b>{{ name }}</b>
                </p>
              </b-col>
              <b-col cols="6">
                <p class="mb-0">username: {{ user.username }}</p>
                <p class="mb-0">code: {{ user.code }}</p>
              </b-col>
            </b-row>
          </template>
          <template #right-action>
            <b-button class="reset-button"
                      variant="transparent"
                      @click="selectUser(user)"
            >
              <sdui-icon class="icon-chevron-right" />
              <span class="sr-only">switch to user {{ user.meta.displayname }}</span>
            </b-button>
          </template>
        </SListItem>
      </SList>
    </SModal>
  </li>
</template>

<script>
export default {
  name: 'CypressUserSwitch',

  data: () => ({
    showAllUsers: false,
    schoolData: {},
  }),

  computed: {
    schoolID() {
      return this.$me?.school.id
    },

    schoolName() {
      return this.$me?.school.name
    },

    limitUsers() {
      return Object.keys(this.users)
        .slice(0, 4)
        .reduce((acc, key) => ({ ...acc, [key]: this.users[key] }), {})
    },

    users() {
      if (!this.schoolData || !Object.keys(this.schoolData).length) return {}
      return {
        ...this.schoolData.users,
        ...Object.values(this.schoolData.users).reduce(
          (acc, user) => ({
            ...acc,
            ...(user.childs || {}),
          }),
          {},
        ),
      }
    },

    selectedUser() {
      return Object.values(this.users).find((el) => Number(el.id) === Number(this.$me?.id))
    },

    hasAdmin() {
      return !!Object.values(this.users).find((user) => user.management)
    },
  },

  methods: {
    async selectUser(user) {
      // clean localStorage
      const keysToKeep = ['file_download_key', 'multiple_users']
      const dataToKeep = keysToKeep.map((key) => localStorage.getItem(key))
      localStorage.clear()
      keysToKeep.map((key, i) => dataToKeep[i] && localStorage.setItem(key, dataToKeep[i]))

      window.localStorage.setItem('auth_token', user.access_token)
      window.localStorage.setItem('sampleSchoolData', JSON.stringify(this.schoolData))
      await this.$store.dispatch('users/resetCacheStorage')
      location.href = '/news'
    },

    switchSchool() {
      this.$router.push({ name: 'settings-user', params: { id: this.$me.id }, query: { modal: 'changeSchool' } })
    },

    keyboardSwitch(event) {
      // select keyboard 0-10 Number
      const userIndex = event.which - 48
      if (event.altKey && event.which === 83 && this.hasAdmin) {
        if (this.selectedUser.management) {
          return this.$toastNotify({
            type: 'error',
            text: 'Der aktuelle Nutzer ist in aus der Management School',
          })
        }
        if ([22231].includes(this.$me.school_id)) {
          return this.$toastNotify({
            type: 'error',
            text: 'Der aktuelle Nutzer ist in der internen Schule',
          })
        }

        return this.switchSchool()
      }

      if (event.altKey && event.which === 68 && import.meta.env.VITE_SAMPLE_SCHOOLS) {
        return this.$router.push({ name: 'cypress-sample-schools-generation' })
      }

      if (!event.altKey || userIndex < 0 || userIndex > Object.keys(this.limitUsers).length) return

      const user = this.limitUsers[Object.keys(this.limitUsers)[userIndex - 1]]
      this.selectUser(user)
    },
  },

  created() {
    this.schoolData = localStorage && JSON.parse(localStorage.getItem('sampleSchoolData') || '{}')

    document.addEventListener('keydown', this.keyboardSwitch)
  },

  unmounted() {
    document.removeEventListener('keydown', this.keyboardSwitch)
  },
}
</script>

<style scoped lang="scss">
.keyboard-navigation button:focus-visible,
.keyboard-navigation a:focus-visible {
  outline-color: $color-white !important;
}

.school-name {
  min-width: 200px;
}

.cypress-user-switch-btn,
.show-all-users-btn,
.change-school-btn,
.monitor-btn {
  // !important styles to override bootstrap button
  border-radius: 5px !important;
  height: 53px !important;
  text-align: left !important;
  width: 100%;
  display: flex !important;
  color: $color-primary-light !important;
  font-weight: $font-weight-normal !important;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding: 15px 0 15px 12px !important;

  .title,
  .subtitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    display: inline-block;
  }

  .show-all-users-btn--icon,
  .change-school-btn--icon,
  .monitor-btn--icon {
    color: $color-primary;
    display: flex;

    .icon {
      background-color: $color-white;
      border-radius: 50%;
      cursor: pointer;
      height: 28px;
      width: 28px;
      position: relative;

      &::before {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
      }
    }
  }
}
</style>
